import useCartQueryOptions from '@/features/cart/queries/useCartQueryOptions';
import { Cart } from '@/features/cart/types/cart';
import useAuthenticatedQuery from '@/shared/hooks/useAuthenticatedQuery';
import { UseQueryOptions } from '@tanstack/react-query';

export default function useCartQuery(options: Omit<UseQueryOptions<Cart>, 'queryKey'> = {}) {
  return useAuthenticatedQuery(useCartQueryOptions(options));
}
